import React from "react";

interface ProgressBarProps {
  currentSectionIndex: number;
  totalSections: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentSectionIndex, totalSections }) => {
  const sectionProgress = ((currentSectionIndex + 1) / totalSections) * 100;
  
  return (
    <div className="mb-4 md:mb-6">
      <div className="flex items-center justify-between">
        <span className="text-xs md:text-sm font-medium text-gray-700">
          Sección {currentSectionIndex + 1} de {totalSections}
        </span>
        <span className="text-xs md:text-sm font-medium text-gray-700">
          {Math.round(sectionProgress)}%
        </span>
      </div>
      <div className="mt-1 md:mt-2 h-1.5 md:h-2 w-full rounded-full bg-gray-200">
        <div
          className="h-1.5 md:h-2 rounded-full bg-brand-500"
          style={{ width: `${sectionProgress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar; 